module.exports = __webpack_public_path__ + "static/img/20201.fb62b0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20201.jpg
// module id = uwbK
// module chunks = 1